import { useLayoutEffect } from 'react';
import type { MouseEvent } from 'react';

/** Mobile WebKit keeps :focus on light buttons after tap — clear so skip stays white. */
export function blurQuizSkipButtonAfterTap(e: MouseEvent<HTMLButtonElement>): void {
  const el = e.currentTarget;
  if (!(el instanceof HTMLElement)) return;
  window.setTimeout(() => {
    el.blur();
  }, 0);
}

export function onQuizSkipClick(handler: () => void): (e: MouseEvent<HTMLButtonElement>) => void {
  return (e) => {
    handler();
    blurQuizSkipButtonAfterTap(e);
  };
}

/** Clears stuck focus when the question index changes (reused button node). */
export function useBlurMobileSkipFocusOnQuestionChange(questionIndex: number): void {
  useLayoutEffect(() => {
    const ae = document.activeElement;
    if (ae instanceof HTMLElement && ae.classList.contains('witc-skip-on-image-btn')) {
      ae.blur();
    }
  }, [questionIndex]);
}
